module.exports = __webpack_public_path__ + "img/Average_1.71a46239.png";